import React from 'react';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Print from '@material-ui/icons/PrintOutlined';
import ReactToPrint from 'react-to-print';
import appConstant from '../../appConstants';
import Events from '../../utilities/EventEmitter';
import { withStyles } from '@material-ui/core/styles';
import { compose } from 'recompose';
import { withAppConfig } from '../../appConfigContext';
import Tooltip from '../../components/common/StyledToolTip';

const styles = (theme) => ({
  paper: {
    maxHeight: '300px',
    backgroundColor: theme.ModalBGColor
  },
  menuItemText: {
    fontSize: '12px',
    padding: '8px',
    color: theme.ColumnHeaderTextColor,
    fontWeight: 600,
    '&:hover': {
      background: theme.customMultiSelectColor
    }
  }
});

class PrintMenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      anchorEl: null,
      routeSelected: false,
      isValidRouteSelection: false
    };
  }

  componentDidMount() {
    this.props.eventHub.on('updateLoadingGuideMenuStatus', this.changeLoadingGuideMenuStatus);
  }

  componentWillUnmount() {
    this.props.eventHub.off('updateLoadingGuideMenuStatus', this.changeLoadingGuideMenuStatus);
  }

  handleClick = (event) => {
    this.setState({
      anchorEl: event.currentTarget
    });
  };

  handleClose = () => {
    this.setState({
      anchorEl: null
    });
  };
  printLoadingManifest = () => {
    Events.emit('PublishNPrint');
    this.handleClose();
  };

  reactToPrintTrigger = () => (
    <MenuItem classes={{ root: this.props.classes.menuItemText }}>Route Map</MenuItem>
  );

  reactToPrintContent = () => {
    const routesMapContainer = this.props.stack.parent.getItemsById(
      // not able get element in any other way
      appConstant.layout.RoutesMap
    );
    return routesMapContainer[0].element[0];
  };

  printLoadingGuideContent = () => {
    Events.emit('PrintLoadingGuide');
    this.handleClose();
  };

  changeLoadingGuideMenuStatus = (selectedRoutes) => {
    const isValidRouteSelection = !selectedRoutes.some(
      ({ routeName }) => routeName === appConstant.UNRTD_ROUTENAME
    );
    this.setState({
      isValidRouteSelection: isValidRouteSelection,
      routeSelected: selectedRoutes.length >= 1
    });
  };

  getTooltipMessage = (itemName) => {
    if (!this.state.routeSelected) {
      return `Select a route to print loading ${itemName}`;
    } else if (!this.state.isValidRouteSelection) {
      return `Loading ${itemName} cannot be printed for Unrtd Routes`;
    }
    return '';
  };

  render() {
    const { classes } = this.props;
    const printFeatureFlag = this.props.featureFlags.find(
      (ele) => ele.id == 'PrintLoadingManifest'
    );
    let showPrintLoadingManifest = false;
    if (printFeatureFlag?.value) {
      showPrintLoadingManifest = true;
    }
    const { anchorEl } = this.state;
    const disablePrint = !this.state.routeSelected || !this.state.isValidRouteSelection;
    return (
      <div title="Print">
        <Print onClick={this.handleClick} />
        <Menu
          getContentAnchorEl={null}
          disableAutoFocusItem
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          open={Boolean(anchorEl)}
          anchorEl={anchorEl}
          onClose={this.handleClose}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          classes={{ paper: classes.paper }}
          MenuListProps={{ disablePadding: true }}>
          {this.props.configJSON?.enablePrintLoadingGuide && (
            <Tooltip title={this.getTooltipMessage('guide')} disableFocusListener>
              <div>
                <MenuItem
                  classes={{ root: classes.menuItemText }}
                  onClick={this.printLoadingGuideContent}
                  disabled={disablePrint}>
                  Loading Guide
                </MenuItem>
              </div>
            </Tooltip>
          )}
          {showPrintLoadingManifest && (
            <Tooltip title={this.getTooltipMessage('manifest')} disableFocusListener>
              <div>
                <MenuItem
                  classes={{ root: classes.menuItemText }}
                  onClick={this.printLoadingManifest}
                  disabled={disablePrint}>
                  Loading Manifest
                </MenuItem>
              </div>
            </Tooltip>
          )}
          <div onClick={this.handleClose}>
            <ReactToPrint
              trigger={this.reactToPrintTrigger}
              content={this.reactToPrintContent}
              copyStyles
              onAfterPrint={this.props.onAfterPrint}
              pageStyle="print"
            />
          </div>
        </Menu>
      </div>
    );
  }
}

export default compose(withStyles(styles), withAppConfig)(PrintMenu);
